;var UpdateFilters = function( newFilter, filterList ) {

  var newFilterIndex = filterList.indexOf( newFilter );

  if ( newFilterIndex < 0 ) {
    filterList.push( newFilter );
  } else {
    filterList.splice( newFilterIndex, 1 );
  }

  return filterList;

}